import { AfterContentChecked, ChangeDetectorRef, Component, inject, input, viewChild, output } from '@angular/core';
import { FormlyFieldConfig } from '@ngx-formly/core';

import { SummaryButton, SummaryItem } from '../../../models';
import { MockEditService } from '../../../mock';
import { BaseEditService, BaseEditCreateService } from '../../../services';
import { BaseEditFormComponent } from '../../base-edit-form/base-edit-form.component';
import { SummaryTopComponent } from '../../summary-top/summary-top.component';

@Component({
  selector: 'app-base-edit-form-modal',
  templateUrl: './base-edit-form-modal.component.html',
  styleUrl: './base-edit-form-modal.component.scss',
  imports: [SummaryTopComponent, BaseEditFormComponent],
})
export class BaseEditFormModalComponent implements AfterContentChecked {
  private readonly cdRef = inject(ChangeDetectorRef);

  public readonly form = viewChild(BaseEditFormComponent);

  public readonly id = input<string>();
  public readonly parentId = input<string>();
  public readonly parentId2 = input<string>();
  public readonly additionalButtons = input<SummaryButton[]>();
  public readonly alwaysShowAdditionalButtons = input(false);
  public readonly alwaysSave = input(false);
  public readonly closeOnSave = input(true);
  public readonly fields = input<FormlyFieldConfig[]>();
  public readonly header = input<string>();
  public readonly showSave = input(true);
  public readonly showBack = input(true);
  public readonly saveButtonText = input($localize`Save`);
  public readonly summaryItems = input<(model: any) => SummaryItem[]>();
  public readonly baseService = input<BaseEditService<any, any> | BaseEditCreateService<any, any>>(
    new MockEditService(),
  );
  public readonly model = input<any>({});
  public readonly modelUpdated = output<any>();
  public readonly saved = output<any>();

  ngAfterContentChecked() {
    this.cdRef.detectChanges();
  }

  updateModel(model: any, markUpdated = true) {
    this.form().updateModel(model, markUpdated);
  }
}
